import React, { useEffect, useState } from "react";
import WineItem from "./WineItem";
import { CATEGORY_API } from "./apiurls";
import WineControls from "./WineControls";

import "./PagesLinks.css";

function PagesLinks() {
  const [categories, setCategories] = useState([]);
  console.log("CURRENT CATEGORIES:", categories);
  const [selectedCatId, setSelectedCatId] = useState("ALL");
  const [selectedShop, setSelectedShop] = useState("");
  const [mlFilter, setMlFilter] = useState(null);
  const [userCoords, setUserCoords] = useState(null);
  const [nearbyShops, setNearbyShops] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [selectedCatName, setSelectedCatName] = useState("ALL");
  useEffect(() => {
    async function fetchCategories() {
        try {
            const res = await fetch(CATEGORY_API);

            console.log("CATEGORY API STATUS:", res.status);

            const data = await res.json();

            console.log("CATEGORY API RESPONSE:", data);

            setCategories(data);
        } catch (err) {
            console.error("CATEGORY API ERROR:", err);
        }
    }

    fetchCategories();
}, []);

  return (
 

 
    <>
      {/* CATEGORY BUTTONS */}
    <div className="pages-links-block">
  <span
   className={`category-item ${selectedCatId === "POPULAR" ? "active" : ""}`}
    onClick={() => {
      setSelectedCatId("POPULAR");
      setSelectedCatName("POPULAR");
    }}
  >
    POPULAR
  </span>

  <span
   className={`category-item ${selectedCatId === "ALL" ? "active" : ""}`}
    onClick={() => {
      setSelectedCatId("ALL");
      setSelectedCatName("ALL");
    }}
  >
    ALL
  </span>

  {categories.map((cat) => (
    <span
        key={cat.cat_id}
        className={`category-item ${
            selectedCatId === cat.cat_id ? "active" : ""
        }`}
        onClick={() => {
            setSelectedCatId(cat.cat_id);
            setSelectedCatName(cat.cat_name);
        }}
    >
        {cat.cat_name}
    </span>
))}
</div>
  <WineControls
    catId={selectedCatId}
    catName={selectedCatName}

    categories={categories}
    selectedCatId={selectedCatId}
    setSelectedCatId={setSelectedCatId}
    setSelectedCatName={setSelectedCatName}

    cbSearch={setSearchValue}
    cbChangedFilter={(shop) => setSelectedShop(shop)}
    cbChangedSort={setMlFilter}
    cbChangeOutputType={() => {}}
    cbSetUserCoords={setUserCoords}
    cbSetNearbyShops={setNearbyShops}

    showLocationSearch={false}
    showSearchBar={true}
    showShopFilter={false}
    showMlFilter={false}
    showPageFilter={false}
  />

      {/* PRODUCTS */}
      <div className="products-card">
  {categories.length === 0 ? (
    <p>Loading categories...</p>
  ) : selectedCatId ? (
    <WineItem cat_id={selectedCatId} allCategories={categories} selectedShop={selectedShop}
      mlFilter={mlFilter}  nearbyShops={nearbyShops}  searchKeyword={searchValue}  />
  ) : (
    <p>Select a category</p>
  )}
</div>
    </>
  );
}

export default PagesLinks;
